<template>
  <div>
    <h2>好きな色はどれ？</h2>
    <p style="text-align:center">
      【無料】パーソナルカラー診断<br><br>
    </p>
    <p style="text-align:left">
      好きな色を選ぶと、コーディネートしやすい色を表示します。
    </p>
    <router-link id="help" to="/help">使い方</router-link>
    <div id="choice-box-default" v-show="isDefault"></div>
    <div id="choice-box" v-show="!isDefault">
    <button
      class="btn"
      v-for="(item, index) in items"
      :key="item.color"
      :style="{ backgroundColor: item.color, color: item.fontColor}"
      v-show="item.isSelected"
      @click="toggleSelection(index)"
    >
    </button>
    </div>
    <button id="check-btn" @click="check" :disabled="isDefault || maxGroupName !== ''">チェック</button>
    <button id="reset-btn" @click="reset" :disabled="isDefault">リセット</button>
    <br>
    <button
      class="btn"
      v-for="(item, index) in items"
      :key="item.color"
      :style="{ backgroundColor: item.color, color: item.fontColor }"
      v-show="!item.isSelected && maxGroupName === ''"
      @click="toggleSelection(index)"
    >
    </button>

    <div id="result" v-show="maxGroupName !== ''">
      <div id="msg">
        {{message[maxGroupName]}}
      </div>
      <h3>おすすめの色</h3>
      <button
        class="btn"
        v-for="item in getColors(colors, maxGroupName)"
        :key="item.color"
        :style="{ backgroundColor: item.color, color: item.fontColor }"
        disabled
      >
      </button>
      <h3>ベーシックカラー</h3>
      <button
        class="btn"
        v-for="item in getColors(basicColors, maxGroupName)"
        :key="item.color"
        :style="{ backgroundColor: item.color, color: item.fontColor }"
        disabled
      >
      </button>
      
    </div>
  </div>
</template>

<script>
import firebase from "firebase"
export default {
  computed: {
    isDefault() {
      // 選択されたものが一つもないときはTrue
      return this.items.filter(item => item.isSelected).length === 0
    }
  },
  data() {
    return {
      items: [
        { name: "v1", color: "rgb(185,31,87)", groups:["su4", "wi4"], isSelected: false },
        { name: "v2", color: "rgb(208,47,72)", groups:["su2", "wi1"], isSelected: false },
        { name: "b2", color: "rgb(239,108,112)", groups:["sp2"], isSelected: false },
        { name: "dp2", color: "rgb(166,29,57)", groups:["au1"], isSelected: false },
        { name: "lt+2", color: "rgb(241,152,150)", groups:["sp1"], isSelected: false },
        { name: "sf2", color: "rgb(202,130,129)", groups:["su3"], isSelected: false },
        { name: "d2", color: "rgb(163,90,92)", groups:["su3"], isSelected: false },
        { name: "dk2", color: "rgb(105,41,52)", groups:["au2"], isSelected: false },
        { name: "p+2", color: "rgb(232,194,191)", groups:["sp1"], isSelected: false },
        { name: "ltg2", color: "rgb(192,171,170)", groups:["su1","su2","su3","su4"], isSelected: false },
        { name: "g2", color: "rgb(116,92,92)", groups:["su1","su2","su3","su4"], isSelected: false },
        { name: "dkg2", color: "rgb(62,45,48)", groups:["wi1","wi2","wi3","wi4"], isSelected: false },
        { name: "v3", color: "rgb(221,68,59)", groups:["sp3","sp4"], isSelected: false },
        { name: "PI1", color: "rgb(250,155,165)", groups:["su1","su4", "wi2","wi4"], isSelected: false },
        { name: "PI2", color: "rgb(255,139,142)", groups:["su4", "wi2","wi4"], isSelected: false },
        { name: "PI3", color: "rgb(243,83,130)", groups:["su4", "wi2","wi4"], isSelected: false },
        { name: "PI4", color: "rgb(200,80,150)", groups:["wi1","wi4"], isSelected: false },
        { name: "PI5", color: "rgb(252,188,194)", groups:["sp1"], isSelected: false },
        { name: "PI6", color: "rgb(244,170,196)", groups:["sp1"], isSelected: false },
        { name: "PI7", color: "rgb(241,127,154)", groups:["sp2"], isSelected: false },
        { name: "PI8", color: "rgb(234,88,119)", groups:["su4"], isSelected: false },
        { name: "PI9", color: "rgb(253,170,137)", groups:["au4"], isSelected: false },
        { name: "PI10", color: "rgb(250,129,85)", groups:["au4"], isSelected: false },
        { name: "v4", color: "rgb(233,91,35)", groups:["au1","au4"], isSelected: false },
        { name: "b4", color: "rgb(250,129,85)", groups:["sp2"], isSelected: false },
        { name: "dp4", color: "rgb(171,61,29)", groups:["au1","au4"], isSelected: false },
        { name: "lt+4", color: "rgb(255,167,135)", groups:["sp1"], isSelected: false },
        { name: "sf4", color: "rgb(218,146,122)", groups:["au3","au4"], isSelected: false },
        { name: "d4", color: "rgb(175,105,84)", groups:["sp4", "au3","au4"], isSelected: false },
        { name: "dk4", color: "rgb(117,54,42)", groups:["au2"], isSelected: false },
        { name: "p+4", color: "rgb(235,194,181)", groups:["sp1"], isSelected: false },
        { name: "v5", color: "rgb(230,120,0)", groups:["sp3","sp4", "au1","au4"], isSelected: false },
        { name: "v6", color: "rgb(244,157,0)", groups:["sp3","sp4"], isSelected: false },
        { name: "b6", color: "rgb(255,173,54)", groups:["sp2"], isSelected: false },
        { name: "dp6", color: "rgb(177,108,0)", groups:["au1","au4"], isSelected: false },
        { name: "lt+6", color: "rgb(255,190,113)", groups:["sp1"], isSelected: false },
        { name: "sf6", color: "rgb(219,166,107)", groups:["au3","au4"], isSelected: false },
        { name: "d6", color: "rgb(179,127,70)", groups:["sp4", "au3","au4"], isSelected: false },
        { name: "dk6", color: "rgb(121,77,28)", groups:["sp1","sp2","sp3","sp4"], isSelected: false },
        { name: "p+6", color: "rgb(244,212,176)", groups:["sp1"], isSelected: false },
        { name: "v7", color: "rgb(241,181,0)", groups:["sp3","sp4", "au1"], isSelected: false },
        { name: "v8", color: "rgb(238,201,0)", groups:["sp3"], isSelected: false },
        { name: "b8", color: "rgb(250,216,49)", groups:["sp2", "su2"], isSelected: false },
        { name: "dp8", color: "rgb(179,147,0)", groups:["au1","au4"], isSelected: false },
        { name: "lt+8", color: "rgb(242,217,110)", groups:["sp1", "su1", "wi2","wi4"], isSelected: false },
        { name: "sf8", color: "rgb(211,189,108)", groups:["au3"], isSelected: false },
        { name: "d8", color: "rgb(171,148,70)", groups:["au3","au4"], isSelected: false },
        { name: "dk8", color: "rgb(116,96,31)", groups:["au2"], isSelected: false },
        { name: "p+8", color: "rgb(242,230,184)", groups:["sp1", "su1", "wi2","wi4"], isSelected: false },
        { name: "g8", color: "rgb(120,111,87)", groups:["au1","au2","au3","au4"], isSelected: false },
        { name: "v9", color: "rgb(210,193,0)", groups:["wi1"], isSelected: false },
        { name: "v10", color: "rgb(168,187,0)", groups:["sp3"], isSelected: false },
        { name: "b10", color: "rgb(183,200,43)", groups:["sp2"], isSelected: false },
        { name: "dp10", color: "rgb(116,132,0)", groups:["au1"], isSelected: false },
        { name: "lt+10", color: "rgb(199,211,109)", groups:["sp1"], isSelected: false },
        { name: "sf10", color: "rgb(173,182,107)", groups:["au3"], isSelected: false },
        { name: "d10", color: "rgb(133,143,70)", groups:["au3"], isSelected: false },
        { name: "dk10", color: "rgb(82,91,32)", groups:["au2"], isSelected: false },
        { name: "p+10", color: "rgb(216,221,173)", groups:["sp1"], isSelected: false },
        { name: "v11", color: "rgb(88,169,29)", groups:["sp3","sp4"], isSelected: false },
        { name: "v12", color: "rgb(0,161,90)", groups:["sp3","sp4"], isSelected: false },
        { name: "b12", color: "rgb(65,184,121)", groups:["sp2"], isSelected: false },
        { name: "dp12", color: "rgb(0,114,67)", groups:["au1","au4"], isSelected: false },
        { name: "lt+12", color: "rgb(133,206,158)", groups:["sp1"], isSelected: false },
        { name: "sf12", color: "rgb(118,177,138)", groups:["au3"], isSelected: false },
        { name: "d12", color: "rgb(79,135,102)", groups:["au3","au4"], isSelected: false },
        { name: "dk12", color: "rgb(35,82,58)", groups:["au2"], isSelected: false },
        { name: "p+12", color: "rgb(174,212,185)", groups:["sp1"], isSelected: false },
        { name: "v13", color: "rgb(0,146,110)", groups:["su4", "wi1"], isSelected: false },
        { name: "v14", color: "rgb(0,133,127)", groups:["wi4"], isSelected: false },
        { name: "b14", color: "rgb(0,170,159)", groups:["su2","su4"], isSelected: false },
        { name: "dp14", color: "rgb(0,102,100)", groups:["wi3"], isSelected: false },
        { name: "lt+14", color: "rgb(98,192,181)", groups:["su1"], isSelected: false },
        { name: "sf14", color: "rgb(84,163,155)", groups:["su3"], isSelected: false },
        { name: "d14", color: "rgb(42,123,118)", groups:["su3"], isSelected: false },
        { name: "dk14", color: "rgb(0,71,70)", groups:["wi3"], isSelected: false },
        { name: "p+14", color: "rgb(166,212,204)", groups:["su1", "wi2","wi4"], isSelected: false },
        { name: "v16", color: "rgb(0,112,155)", groups:["au1"], isSelected: false },
        { name: "b16", color: "rgb(0,152,185)", groups:["sp2","sp3", "wi2"], isSelected: false },
        { name: "dp16", color: "rgb(0,84,118)", groups:["au1"], isSelected: false },
        { name: "lt+16", color: "rgb(91,175,196)", groups:["sp1"], isSelected: false },
        { name: "sf16", color: "rgb(81,146,164)", groups:["au3"], isSelected: false },
        { name: "d16", color: "rgb(36,106,125)", groups:["au3"], isSelected: false },
        { name: "dk16", color: "rgb(0,69,88)", groups:["au1","au2","au3","au4"], isSelected: false },
        { name: "p+16", color: "rgb(173,209,218)", groups:["sp1"], isSelected: false },
        { name: "v18", color: "rgb(0,91,165)", groups:["su4", "wi1","wi4"], isSelected: false },
        { name: "b18", color: "rgb(41,129,192)", groups:["su2","su4", "wi2"], isSelected: false },
        { name: "dp18", color: "rgb(0,66,128)", groups:["sp1","sp2","sp3","sp4"], isSelected: false },
        { name: "lt+18", color: "rgb(108,154,197)", groups:["su1"], isSelected: false },
        { name: "sf18", color: "rgb(93,126,160)", groups:["su3"], isSelected: false },
        { name: "d18", color: "rgb(52,89,125)", groups:["su3"], isSelected: false },
        { name: "dk18", color: "rgb(18,52,82)", groups:["wi1","wi2","wi3","wi4"], isSelected: false },
        { name: "p+18", color: "rgb(175,192,209)", groups:["su1", "wi2","wi4"], isSelected: false },
        { name: "ltg18", color: "rgb(155,165,175)", groups:["su1","su2","su3","su4"], isSelected: false },
        { name: "v19", color: "rgb(26,84,165)", groups:["su4", "wi1","wi4"], isSelected: false },
        { name: "v20", color: "rgb(83,74,160)", groups:["su4", "wi1","wi4"], isSelected: false },
        { name: "b20", color: "rgb(117,116,188)", groups:["sp2","sp3", "su2","su4", "wi2"], isSelected: false },
        { name: "dp20", color: "rgb(62,51,123)", groups:["wi3"], isSelected: false },
        { name: "lt+20", color: "rgb(144,145,195)", groups:["sp1", "su1"], isSelected: false },
        { name: "sf20", color: "rgb(120,120,160)", groups:["su3"], isSelected: false },
        { name: "d20", color: "rgb(84,82,124)", groups:["su3"], isSelected: false },
        { name: "dk20", color: "rgb(50,45,81)", groups:["su1","su2","su3","su4"], isSelected: false },
        { name: "p+20", color: "rgb(187,189,208)", groups:["sp1", "su1", "wi2","wi4"], isSelected: false },
        { name: "v21", color: "rgb(112,63,150)", groups:["sp3", "su4", "wi1","wi4"], isSelected: false },
        { name: "v22", color: "rgb(129,55,138)", groups:["sp3", "su4", "wi1","wi4"], isSelected: false },
        { name: "b22", color: "rgb(161,101,168)", groups:["sp2", "su2","su4", "wi2"], isSelected: false },
        { name: "dp22", color: "rgb(97,36,105)", groups:["wi3"], isSelected: false },
        { name: "lt+22", color: "rgb(176,136,181)", groups:["sp1", "su1"], isSelected: false },
        { name: "sf22", color: "rgb(144,113,148)", groups:["su3", "au3"], isSelected: false },
        { name: "d22", color: "rgb(108,74,113)", groups:["su3", "au3"], isSelected: false },
        { name: "dk22", color: "rgb(67,40,72)", groups:["wi3"], isSelected: false },
        { name: "p+22", color: "rgb(200,185,201)", groups:["sp1", "su1", "wi2","wi4"], isSelected: false },
        { name: "v23", color: "rgb(143,46,124)", groups:["su4", "wi1","wi4"], isSelected: false },
        { name: "v24", color: "rgb(173,46,108)", groups:["wi4"], isSelected: false },
        { name: "b24", color: "rgb(208,103,142)", groups:["su2", "wi2"], isSelected: false },
        { name: "dp24", color: "rgb(134,29,85)", groups:["wi3"], isSelected: false },
        { name: "lt+24", color: "rgb(217,142,165)", groups:["su1"], isSelected: false },
        { name: "sf24", color: "rgb(180,120,139)", groups:["su3"], isSelected: false },
        { name: "d24", color: "rgb(139,79,101)", groups:["su3"], isSelected: false },
        { name: "dk24", color: "rgb(97,45,70)", groups:["wi3"], isSelected: false },
        { name: "FL4", color: "rgb(240,194,144)", groups:["sp1","sp2","sp3","sp4"], isSelected: false },
        { name: "FL5", color: "rgb(219,163,107)", groups:["sp4", "au1","au2","au3","au4"], isSelected: false },
        { name: "offN1", color: "rgb(251,241,229)", groups:["su1","su2","su3","su4"], isSelected: false },
        { name: "offN2", color: "rgb(243,230,197)", groups:["sp1","sp2","sp3","sp4"], isSelected: false },
        { name: "offN4", color: "rgb(245,224,193)", groups:["au1","au2","au3","au4"], isSelected: false },
        { name: "BR7", color: "rgb(95,80,59)", groups:["au1","au2","au3","au4"], isSelected: false },
        { name: "W", color: "rgb(255,255,255)", groups:["wi1","wi2","wi3","wi4"], isSelected: false },
        { name: "Gy3.5", color: "rgb(84,84,84)", groups:["wi1","wi2","wi3","wi4"], isSelected: false },
        { name: "BK", color: "rgb(0,0,0)", groups:["wi1","wi2","wi3","wi4"], isSelected: false }
      ],
      colors: [
        { name: "v1", color: "rgb(185,31,87)", groups:["su4", "wi4"], label: "いちごいろ", fontColor: "white" },
        { name: "v2", color: "rgb(208,47,72)", groups:["su2", "wi1"], label: "レッド", fontColor: "white" },
        { name: "v3", color: "rgb(221,68,59)", groups:["sp3","sp4"], label: "スカーレット", fontColor: "black" },
        { name: "v4", color: "rgb(233,91,35)", groups:["au1","au4"], label: "かきいろ", fontColor: "black" },
        { name: "v5", color: "rgb(230,120,0)", groups:["sp3","sp4", "au1","au4"], label: "オレンジ", fontColor: "black" },
        { name: "v6", color: "rgb(244,157,0)", groups:["sp3","sp4"], label: "みかんいろ", fontColor: "black" },
        { name: "v7", color: "rgb(241,181,0)", groups:["sp3","sp4", "au1"], label: "クロームイエロー", fontColor: "black" },
        { name: "v8", color: "rgb(238,201,0)", groups:["sp3"], label: "ジョンブリアン", fontColor: "black" },
        { name: "v9", color: "rgb(210,193,0)", groups:["wi1"], label: "わかくさいろ", fontColor: "black" },
        { name: "v10", color: "rgb(168,187,0)", groups:["sp3"], label: "もえぎ", fontColor: "black" },
        { name: "v11", color: "rgb(88,169,29)", groups:["sp3","sp4"], label: "みどり", fontColor: "black" },
        { name: "v12", color: "rgb(0,161,90)", groups:["sp3","sp4"], label: "エメラルドグリーン", fontColor: "white" },
        { name: "v13", color: "rgb(0,146,110)", groups:["su4", "wi1"], label: "クロームグリーン", fontColor: "white" },
        { name: "v14", color: "rgb(0,133,127)", groups:["wi4"], label: "ビリジアン", fontColor: "white" },
        { name: "v16", color: "rgb(0,112,155)", groups:["au1"], label: "ダックブルー", fontColor: "white" },
        { name: "v18", color: "rgb(0,91,165)", groups:["su4", "wi1","wi4"], label: "コバルトブルー", fontColor: "white" },
        { name: "v19", color: "rgb(26,84,165)", groups:["su4", "wi1","wi4"], label: "オリエンタルブルー", fontColor: "white" },
        { name: "v20", color: "rgb(83,74,160)", groups:["su4", "wi1","wi4"], label: "しおんいろ", fontColor: "white" },
        { name: "v21", color: "rgb(112,63,150)", groups:["sp3", "su4", "wi1","wi4"], label: "すみれいろ", fontColor: "white" },
        { name: "v22", color: "rgb(129,55,138)", groups:["sp3", "su4", "wi1","wi4"], label: "むらさき", fontColor: "white" },
        { name: "v23", color: "rgb(143,46,124)", groups:["su4", "wi1","wi4"], label: "ピアニー", fontColor: "white" },
        { name: "v24", color: "rgb(173,46,108)", groups:["wi4"], label: "マゼンタ", fontColor: "white" },
        { name: "b2", color: "rgb(239,108,112)", groups:["sp2"], label: "コーラルピンク", fontColor: "black" },
        { name: "b4", color: "rgb(250,129,85)", groups:["sp2"], label: "オーロラ", fontColor: "black" },
        { name: "b6", color: "rgb(255,173,54)", groups:["sp2"], label: "ひまわり", fontColor: "black" },
        { name: "b8", color: "rgb(250,216,49)", groups:["sp2", "su2"], label: "イエロー", fontColor: "black" },
        { name: "b10", color: "rgb(183,200,43)", groups:["sp2"], label: "ひわいろ", fontColor: "black" },
        { name: "b12", color: "rgb(65,184,121)", groups:["sp2"], label: "コバルトグリーン", fontColor: "black" },
        { name: "b14", color: "rgb(0,170,159)", groups:["su2","su4"], label: "ピーコックグリーン", fontColor: "black" },
        { name: "b16", color: "rgb(0,152,185)", groups:["sp2","sp3", "wi2"], label: "ターコイズブルー", fontColor: "black" },
        { name: "b18", color: "rgb(41,129,192)", groups:["su2","su4", "wi2"], label: "つゆくさいろ", fontColor: "black" },
        { name: "b20", color: "rgb(117,116,188)", groups:["sp2","sp3", "su2","su4", "wi2"], label: "ウィスタリア", fontColor: "black" },
        { name: "b22", color: "rgb(161,101,168)", groups:["sp2", "su2","su4", "wi2"], label: "あやめいろ", fontColor: "black" },
        { name: "b24", color: "rgb(208,103,142)", groups:["su2", "wi2"], label: "ローズレッド", fontColor: "black" },
        { name: "dp2", color: "rgb(166,29,57)", groups:["au1"], label: "あかねいろ", fontColor: "white" },
        { name: "dp4", color: "rgb(171,61,29)", groups:["au1","au4"], label: "カッパーレッド", fontColor: "white" },
        { name: "dp6", color: "rgb(177,108,0)", groups:["au1","au4"], label: "だいだいいろ", fontColor: "white" },
        { name: "dp8", color: "rgb(179,147,0)", groups:["au1","au4"], label: "からしいろ", fontColor: "white" },
        { name: "dp10", color: "rgb(116,132,0)", groups:["au1"], label: "フォリッジグリーン", fontColor: "white" },
        { name: "dp12", color: "rgb(0,114,67)", groups:["au1","au4"], label: "ときわいろ", fontColor: "white" },
        { name: "dp14", color: "rgb(0,102,100)", groups:["wi3"], label: "かものはいろ", fontColor: "white" },
        { name: "dp16", color: "rgb(0,84,118)", groups:["au1"], label: "なんどいろ", fontColor: "white" },
        { name: "dp20", color: "rgb(62,51,123)", groups:["wi3"], label: "パンジー", fontColor: "white" },
        { name: "dp22", color: "rgb(97,36,105)", groups:["wi3"], label: "ロイヤルパープル", fontColor: "white" },
        { name: "dp24", color: "rgb(134,29,85)", groups:["wi3"], label: "ワインレッド", fontColor: "white" },
        { name: "lt+2", color: "rgb(241,152,150)", groups:["sp1"], label: "さんごいろ", fontColor: "black" },
        { name: "lt+4", color: "rgb(255,167,135)", groups:["sp1"], label: "サーモンピンク", fontColor: "black" },
        { name: "lt+6", color: "rgb(255,190,113)", groups:["sp1"], label: "あんずいろ", fontColor: "black" },
        { name: "lt+8", color: "rgb(242,217,110)", groups:["sp1", "su1", "wi2","wi4"], label: "レモンイエロー", fontColor: "black" },
        { name: "lt+10", color: "rgb(199,211,109)", groups:["sp1"], label: "ひわいろ", fontColor: "black" },
        { name: "lt+12", color: "rgb(133,206,158)", groups:["sp1"], label: "ミントグリーン", fontColor: "black" },
        { name: "lt+14", color: "rgb(98,192,181)", groups:["su1"], label: "せいじいろ", fontColor: "black" },
        { name: "lt+16", color: "rgb(91,175,196)", groups:["sp1"], label: "しんばしいろ", fontColor: "black" },
        { name: "lt+18", color: "rgb(108,154,197)", groups:["su1"], label: "スカイブルー", fontColor: "black" },
        { name: "lt+20", color: "rgb(144,145,195)", groups:["sp1", "su1"], label: "ふじいろ", fontColor: "black" },
        { name: "lt+22", color: "rgb(176,136,181)", groups:["sp1", "su1"], label: "オーキッド", fontColor: "black" },
        { name: "lt+24", color: "rgb(217,142,165)", groups:["su1"], label: "なでしこいろ", fontColor: "black" },
        { name: "sf2", color: "rgb(202,130,129)", groups:["su3"], label: "うすくれない", fontColor: "black" },
        { name: "sf4", color: "rgb(218,146,122)", groups:["au3","au4"], label: "サーモンピンク", fontColor: "black" },
        { name: "sf6", color: "rgb(219,166,107)", groups:["au3","au4"], label: "ゴールデンイエロー", fontColor: "black" },
        { name: "sf8", color: "rgb(211,189,108)", groups:["au3"], label: "ミモザ", fontColor: "black" },
        { name: "sf10", color: "rgb(173,182,107)", groups:["au3"], label: "まっちゃいろ", fontColor: "black" },
        { name: "sf12", color: "rgb(118,177,138)", groups:["au3"], label: "わかなえいろ", fontColor: "black" },
        { name: "sf14", color: "rgb(84,163,155)", groups:["su3"], label: "ターコイズグリーン", fontColor: "black" },
        { name: "sf16", color: "rgb(81,146,164)", groups:["au3"], label: "さびあさぎ", fontColor: "black" },
        { name: "sf18", color: "rgb(93,126,160)", groups:["su3"], label: "ポースリンブルー", fontColor: "black" },
        { name: "sf20", color: "rgb(120,120,160)", groups:["su3"], label: "りんどういろ", fontColor: "black" },
        { name: "sf22", color: "rgb(144,113,148)", groups:["su3", "au3"], label: "はしたいろ", fontColor: "black" },
        { name: "sf24", color: "rgb(180,120,139)", groups:["su3"], label: "オールドローズ", fontColor: "black" },
        { name: "d2", color: "rgb(163,90,92)", groups:["su3"], label: "テラコッタ", fontColor: "white" },
        { name: "d4", color: "rgb(175,105,84)", groups:["sp4", "au3","au4"], label: "かわらけいろ", fontColor: "white" },
        { name: "d6", color: "rgb(179,127,70)", groups:["sp4", "au3","au4"], label: "こはくいろ", fontColor: "white" },
        { name: "d8", color: "rgb(171,148,70)", groups:["au3","au4"], label: "マスタード", fontColor: "white" },
        { name: "d10", color: "rgb(133,143,70)", groups:["au3"], label: "フォリッジグリーン", fontColor: "white" },
        { name: "d12", color: "rgb(79,135,102)", groups:["au3","au4"], label: "ろくしょういろ", fontColor: "white" },
        { name: "d14", color: "rgb(42,123,118)", groups:["su3"], label: "ナイルブルー", fontColor: "white" },
        { name: "d16", color: "rgb(36,106,125)", groups:["au3"], label: "サックスブルー", fontColor: "white" },
        { name: "d18", color: "rgb(52,89,125)", groups:["su3"], label: "アクアマリン", fontColor: "white" },
        { name: "d20", color: "rgb(84,82,124)", groups:["su3"], label: "かちいろ", fontColor: "white" },
        { name: "d22", color: "rgb(108,74,113)", groups:["su3", "au3"], label: "こだいむらさき", fontColor: "white" },
        { name: "d24", color: "rgb(139,79,101)", groups:["su3"], label: "オールドローズ", fontColor: "white" },
        { name: "dk2", color: "rgb(105,41,52)", groups:["au2"], label: "ワインレッド", fontColor: "white" },
        { name: "dk4", color: "rgb(117,54,42)", groups:["au2"], label: "えびちゃ", fontColor: "white" },
        { name: "dk8", color: "rgb(116,96,31)", groups:["au2"], label: "オリーブ", fontColor: "white" },
        { name: "dk10", color: "rgb(82,91,32)", groups:["au2"], label: "モスグリーン", fontColor: "white" },
        { name: "dk12", color: "rgb(35,82,58)", groups:["au2"], label: "ハンターグリーン", fontColor: "white" },
        { name: "dk14", color: "rgb(0,71,70)", groups:["wi3"], label: "ボトルグリーン", fontColor: "white" },
        { name: "dk22", color: "rgb(67,40,72)", groups:["wi3"], label: "しこん", fontColor: "white" },
        { name: "dk24", color: "rgb(97,45,70)", groups:["wi3"], label: "えびいろ", fontColor: "white" },
        { name: "p+2", color: "rgb(232,194,191)", groups:["sp1"], label: "シェルピンク", fontColor: "black" },
        { name: "p+4", color: "rgb(235,194,181)", groups:["sp1"], label: "ネールピンク", fontColor: "black" },
        { name: "p+6", color: "rgb(244,212,176)", groups:["sp1"], label: "レグホーン", fontColor: "black" },
        { name: "p+8", color: "rgb(242,230,184)", groups:["sp1", "su1", "wi2","wi4"], label: "クリームイエロー", fontColor: "black" },
        { name: "p+10", color: "rgb(216,221,173)", groups:["sp1"], label: "びゃくろく", fontColor: "black" },
        { name: "p+12", color: "rgb(174,212,185)", groups:["sp1"], label: "ライムグリーン", fontColor: "black" },
        { name: "p+14", color: "rgb(166,212,204)", groups:["su1", "wi2","wi4"], label: "アイスグリーン", fontColor: "black" },
        { name: "p+16", color: "rgb(173,209,218)", groups:["sp1"], label: "みずいろ", fontColor: "black" },
        { name: "p+18", color: "rgb(175,192,209)", groups:["su1", "wi2","wi4"], label: "フォッグ", fontColor: "black" },
        { name: "p+20", color: "rgb(187,189,208)", groups:["sp1", "su1", "wi2","wi4"], label: "ふじいろ", fontColor: "black" },
        { name: "p+22", color: "rgb(200,185,201)", groups:["sp1", "su1", "wi2","wi4"], label: "ライラック", fontColor: "black" },
        { name: "PI1", color: "rgb(250,155,165)", groups:["su1","su4", "wi2","wi4"], label: "ときいろ", fontColor: "black" },
        { name: "PI2", color: "rgb(255,139,142)", groups:["su4", "wi2","wi4"], label: "ピンク", fontColor: "black" },
        { name: "PI3", color: "rgb(243,83,130)", groups:["su4", "wi2","wi4"], label: "ピンク", fontColor: "black" },
        { name: "PI4", color: "rgb(200,80,150)", groups:["wi1","wi4"], label: "ショッキングピンク", fontColor: "black" },
        { name: "PI5", color: "rgb(252,188,194)", groups:["sp1"], label: "コーラルレッド", fontColor: "black" },
        { name: "PI6", color: "rgb(244,170,196)", groups:["sp1"], label: "こうばいいろ", fontColor: "black" },
        { name: "PI7", color: "rgb(241,127,154)", groups:["sp2"], label: "ももいろ", fontColor: "black" },
        { name: "PI8", color: "rgb(234,88,119)", groups:["su4"], label: "ばらいろ", fontColor: "black" },
        { name: "PI9", color: "rgb(253,170,137)", groups:["au4"], label: "サーモンピンク", fontColor: "black" },
        { name: "PI10", color: "rgb(250,129,85)", groups:["au4"], label: "べにさんご", fontColor: "black" },
      ],
      basicColors: [
        { name: "dp18", color: "rgb(0,66,128)", groups:["sp1","sp2","sp3","sp4"], label: "サファイアブルー", fontColor: "white" },
        { name: "dk6", color: "rgb(121,77,28)", groups:["sp1","sp2","sp3","sp4"], label: "くりいろ", fontColor: "white" },
        { name: "dk16", color: "rgb(0,69,88)", groups:["au1","au2","au3","au4"], label: "マリンブルー", fontColor: "white" },
        { name: "dk18", color: "rgb(18,52,82)", groups:["wi1","wi2","wi3","wi4"], label: "ネイビー", fontColor: "white" },
        { name: "dk20", color: "rgb(50,45,81)", groups:["su1","su2","su3","su4"], label: "あおかち", fontColor: "white" },
        { name: "ltg2", color: "rgb(192,171,170)", groups:["su1","su2","su3","su4"], label: "ピンクベージュ", fontColor: "black" },
        { name: "ltg18", color: "rgb(155,165,175)", groups:["su1","su2","su3","su4"], label: "ブルーグレー", fontColor: "black" },
        { name: "g2", color: "rgb(116,92,92)", groups:["su1","su2","su3","su4"], label: "うめねず", fontColor: "white" },
        { name: "g8", color: "rgb(120,111,87)", groups:["au1","au2","au3","au4"], label: "りかんちゃ", fontColor: "white" },
        { name: "dkg2", color: "rgb(62,45,48)", groups:["wi1","wi2","wi3","wi4"], label: "マーリー", fontColor: "white" },
        { name: "W", color: "rgb(255,255,255)", groups:["wi1","wi2","wi3","wi4"], label: "ホワイト", fontColor: "black" },
        { name: "Gy3.5", color: "rgb(84,84,84)", groups:["wi1","wi2","wi3","wi4"], label: "グレー", fontColor: "white" },
        { name: "BK", color: "rgb(0,0,0)", groups:["wi1","wi2","wi3","wi4"], label: "ブラック", fontColor: "white" },
        { name: "FL4", color: "rgb(240,194,144)", groups:["sp1","sp2","sp3","sp4"], label: "サンライト", fontColor: "black" },
        { name: "FL5", color: "rgb(219,163,107)", groups:["sp4", "au1","au2","au3","au4"], label: "アプリコット", fontColor: "black" },
        { name: "offN1", color: "rgb(251,241,229)", groups:["su1","su2","su3","su4"], label: "オフホワイト", fontColor: "black" },
        { name: "offN2", color: "rgb(243,230,197)", groups:["sp1","sp2","sp3","sp4"], label: "アイボリー", fontColor: "black" },
        { name: "offN4", color: "rgb(245,224,193)", groups:["au1","au2","au3","au4"], label: "クリームイエロー", fontColor: "black" },
        { name: "BR7", color: "rgb(95,80,59)", groups:["au1","au2","au3","au4"], label: "こげちゃ", fontColor: "white" }
      ],
      message: {
        "sp1": "あなたは、やさしいパステルカラーが好きなんですね。\nとてもかわいくて、やさしいイメージです。\nそれぞれのカラーが控えめなので、何色か一緒に使っても、１色をたっぷり使っても大丈夫です。",
        "sp2": "あなたは、明るいカラーが好きなんですね。\n明るくて、いきいきしたイメージです。\nそれぞれのカラーが個性的なので、ベーシックカラーとおすすめの色から２色くらいに絞ってあわせるといいですよ。",
        "sp3": "あなたは、あざやかなカラーが好きなんですね。\n明るく、華やかで、活動的なイメージです。\nそれぞれのカラーが個性的なので、ベーシックカラーとおすすめの色から２色くらいに絞ってあわせるといいですよ。",
        "sp4": "あなたは、強めのカラーがすきなんですね。\n華やかで、ゴージャスなイメージです。\nそれぞれのカラーが個性的なので、ベーシックカラーとおすすめの色から２色くらいに絞ってあわせるといいですよ。",
        "su1": "あなたは、やさしいパステルカラーが好きなんですね。\nやさしくて、かわいくて、ロマンティックなイメージです。\nそれぞれのカラーが控えめなので、何色か一緒に使っても、１色をたっぷり使っても大丈夫です。",
        "su2": "あなたは、ブルーベースの明るいカラーが好きなんですね。\n華やかで、エレガントなイメージです。\nそれぞれのカラーが個性的なので、ベーシックカラーとおすすめの色から２色くらいに絞ってあわせるといいですよ。",
        "su3": "あなたは、シックなカラーが好きなんですね。\n上品で、落ち着いたイメージです。\n顔映りを悪くするかもしれないむずかしいカラーなので、顔の近くに使っていいかドレープをあてて調べることをおすすめします。",
        "su4": "あなたは、ブルーベースのはっきりしたカラーが好きなんですね。\nクールで、かっこいいイメージです。\nそれぞれのカラーが個性的なので、ベーシックカラーとおすすめの色から２色くらいに絞ってあわせるといいですよ。",
        "au1": "あなたは、強めのカラーがすきなんですね。\n華やかで、ゴージャスなイメージです。\nそれぞれのカラーが個性的なので、ベーシックカラーとおすすめの色から２色くらいに絞ってあわせるといいですよ。",
        "au2": "あなたは、落ち着いたカラーがすきなんですね。\n顔映りを悪くするかもしれないむずかしいカラーなので、顔の近くに使っていいかドレープをあてて調べることをおすすめします。",
        "au3": "あなたは、深みのあるカラーが好きなんですね。\nおとなっぽくて、クラシックなイメージです。\nそれぞれのカラーが個性的なので、ベーシックカラーとおすすめの色から２色くらいに絞ってあわせるといいですよ。",
        "au4": "あなたは、エスニックなカラーがすきなんですね。\nとても個性的なイメージです。\nそれぞれのカラーが個性的なので、ベーシックカラーとおすすめの色から２色くらいに絞ってあわせるといいですよ。",
        "wi1": "あなたは、ブルーベースのあざやかなカラーが好きなんですね。\nインパクトがあって、ドラマティックなイメージです。\nそれぞれのカラーが個性的なので、ベーシックカラーとおすすめの色から２色までに絞ってメリハリをつけてあわせるといいですよ。",
        "wi2": "あなたは、ブルーベースの明るいカラーが好きなんですね。\nスタイリッシュなイメージです。\nおすすめの色から、こいカラーとうすいカラーを組み合わせて、メリハリをつけてあわせるといいですよ。",
        "wi3": "あなたは、ブルーベースのこいカラーが好きなんですね。\nかっこいいイメージです。\nそれぞれのカラーが個性的なので、ベーシックカラーとおすすめの色から２色までに絞ってメリハリをつけてあわせるといいですよ。",
        "wi4": "あなたは、ブルーベースのはっきりしたカラーが好きなんですね。\nモダンで、シャープなイメージです。\nそれぞれのカラーが個性的なので、ベーシックカラーとおすすめの色から２色までに絞ってメリハリをつけてあわせるといいですよ。"
      },
      msg: "",
      maxGroupName: ""
    };
  },
  methods: {
    toggleSelection(index) {
      this.items[index].isSelected = !this.items[index].isSelected
      if (this.maxGroupName !== "") {
        this.reset()
      }
    },
    colorGroupCount() {
      // getMaxGroupNameの使用時の優先度の高いもの順
      var counter = {
        sp: 0, sp1: 0, sp2: 0, sp3: 0, sp4: 0,
        wi: 0, wi1: 0, wi2: 0, wi3: 0, wi4: 0,
        su: 0, su1: 0, su2: 0, su3: 0, su4: 0,
        au: 0, au1: 0, au2: 0, au3: 0, au4: 0,
      }
      var selectedColors = this.items.filter(item => item.isSelected)
      selectedColors.forEach(item => {
        item.groups.forEach(group => {
          counter[group]++
        })
      })
      return counter
    },
    getColors(colors, groupName) {
      var results = []
      colors.forEach(color => {
        color.groups.forEach(group => {
          if (group === groupName) {
            results[results.length] = color
          }
        })
      })
      return results
    },
    getMaxGroupName(counter) {
      // 一つ以上選択され最も選択されたグループ名を取得
      var max = 0
      var maxGroupName = ""
      Object.keys(counter).forEach(groupName => {
        if (max < counter[groupName]) {
          max = counter[groupName]
          maxGroupName = groupName
        }
      })
      return maxGroupName
    },
    check() {
      // maxGroupNameを設定することで画面表示が切り替わる
      var counter = this.colorGroupCount()
      this.maxGroupName = this.getMaxGroupName(counter)
      // 
      const selectedColors = this.items.filter(item => item.isSelected)
      selectedColors.forEach(color => {
        firebase.firestore().collection(`colors`).doc(color.name).get().then(snapshot => {
          var count = snapshot.data().selectedCount + 1
          firebase.firestore().collection(`colors`).doc(color.name).set({
            name: color.name,
            selectedCount: count
          })
        }).catch(() => {
          firebase.firestore().collection(`colors`).doc(color.name).set({
            name: color.name,
            selectedCount: 1
          })
        })
      })
    },
    reset() {
      var selectedColors = this.items.filter(item => item.isSelected)
      selectedColors.forEach(item => {
        item.isSelected = false
      })
      this.maxGroupName = ""
    },
    labelStr(label) {
      return label
    }
  }
}
</script>

<style scoped>
.btn {
  height: 50px;
  width: 80px;
  border-radius: 8px;
  font-size: 10px;
  vertical-align: middle;
  margin: 15px;
  border-color: rgba(118, 118, 118, 0.3);
}
#check-btn {
  height: 40px;
  width: 160px;
  border-radius: 20px;
  margin-top: 20px;
  margin-bottom: 10px;
  margin-right: 10px;
  background-color: rgba(231, 142, 26, 0.39);
  font-size: 16pt;
  font-family: '丸フォーク M';
  color: rgb(121, 77, 28);
  vertical-align: middle;
  border-color: rgba(118, 118, 118, 0.3);
}
#reset-btn {
  height: 40px;
  width: 160px;
  border-radius: 20px;
  margin-top: 20px;
  margin-bottom: 10px;
  background-color: white;
  font-size: 16pt;
  font-family: '丸フォーク M';
  color: rgb(121, 77, 28);
  vertical-align: middle;
  border-color: rgba(118, 118, 118, 0.3);
}
#choice-box {
  border-style: solid;
  border-width: 2px;
  border-color: rgb(121, 77, 28);
  border-radius: 8px;
}
#choice-box-default {
  border-style: solid;
  border-width: 2px;
  border-color: rgb(121, 77, 28);
  height: 51px;
  border-radius: 8px;
}
h3 {
  margin-top: 10px;
  margin-bottom: 0px;
}
#help {
  position:fixed;
  top: 14px;
  right: 30px;
  text-decoration: none;
  color:rgb(121, 77, 28);
  z-index: 1000;
}
#msg {
  text-align: left;
  white-space: pre-line;
}
</style>
